import { gql } from '@apollo/client';

export const GET_TASK_EXECUTION_BY_ID = gql`
    query GetTaskExecutionById($id: Long!) {
        getTaskExecutionById(id: $id) {
            id
            taskName
            taskSpec
            status
            startedAt
            endedAt
            durationSeconds
            message
            serverIp
            hostname
            createdAt
            updatedAt
        }
    }
`;

export interface TaskExecutionType {
    id: string;
    taskName: string;
    taskSpec?: string;
    status: number;
    startedAt?: string;
    endedAt?: string;
    durationSeconds?: number;
    message?: string;
    serverIp?: string;
    hostname?: string;
    createdAt?: string;
    updatedAt?: string;
}

export interface GetTaskExecutionByIdResponse {
    getTaskExecutionById: TaskExecutionType | null;
}
